import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';



import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { ClickToComponent } from 'click-to-react-component';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import '@/styles/animation.css';
import '@/styles/cover.less';
import '@/styles/global.less';
import '@/styles/index.css';
import '@/styles/var.css';
import { setDocumentLanguage } from '@/utils/languageUtils';
import { initSystemDetector } from '@/utils/systemDetector';
import { initWeblogger } from '@/utils/weblogger';

import '../assets/Urbanist.css';
import '../assets/poppins-font.css';
import '../assets/manrope-font.css';
import { App } from './App';
import './index.css';

initWeblogger();
initSystemDetector();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,

    // Backend 配置 - 指定翻译文件的加载路径
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // 添加更多调试选项
      crossDomain: false,
      allowMultiLoading: false,
    },

    // LanguageDetector 配置
    detection: {
      // 检测顺序：URL参数 -> Cookie -> LocalStorage -> 浏览器语言 -> HTML标签
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],

      // 各种检测方式的配置
      lookupQuerystring: 'lng', // URL参数名: ?lng=zh-CN
      lookupCookie: 'i18next', // Cookie名称
      lookupLocalStorage: 'i18nextLng', // LocalStorage键名
      lookupFromPathIndex: 0, // 从URL路径检测语言的位置
      lookupFromSubdomainIndex: 0, // 从子域名检测语言的位置

      // 缓存设置
      caches: ['localStorage', 'cookie'], // 将检测到的语言缓存到这些位置
      excludeCacheFor: ['cimode'], // 排除缓存的语言

      // Cookie配置
      cookieMinutes: 10080, // Cookie过期时间（7天）
      cookieDomain: window.location.hostname, // Cookie域名

      // HTML标签检测
      htmlTag: document.documentElement, // 检测HTML标签的lang属性

      // 只检测这些语言
      checkWhitelist: true, // 启用白名单检查
    },

    // 支持的语言列表
    supportedLngs: ['en', 'zh'],

    // 语言映射：将检测到的语言代码映射到支持的语言
    load: 'languageOnly', // 只加载语言部分，忽略地区代码

    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    // i18n 初始化完成后，设置文档语言属性
    setDocumentLanguage();

    // 监听语言变化，动态更新文档属性
    i18n.on('languageChanged', (lng) => {
      setDocumentLanguage(lng);
    });
  });

if (import.meta.env.PROD) {
  disableReactDevTools();
}

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
  <StrictMode>
    <App />
    <ClickToComponent />
  </StrictMode>,
);